import React from "react";
import "../src/styles/index.scss";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
// window.addEventListener("error", (event) => {
//   console.error("Global error caught:", event.message, event.error);
//   alert("Something went wrong. The page will reload.");
//   window.location.reload();
// });
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
